<div [formGroup]="group">
  @switch (field?.type) {
    <!-- checkbox -->
    @case (fieldTypes.CHECKBOX.type) {
      <div class="input-wrapper">
        <mat-checkbox formControlName="{{controlName}}">{{field.name}}</mat-checkbox>
      </div>
    }
    <!-- date -->
    @case (fieldTypes.DATE.type) {
      <div>
        <mat-form-field [ngClass]="{'full-width': fullWidth}">
          <input [required]="required" matInput [matDatepicker]="picker" readonly (click)="picker.open()" (onSelect)="onDateSelect()" formControlName="{{controlName}}" placeholder="{{field.name}}" >
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          @if (group.value[controlName]) {
            <mat-datepicker-toggle matSuffix (click)="removeDate()">
              <mat-icon matDatepickerToggleIcon>cancel</mat-icon>
            </mat-datepicker-toggle>
          }
          <mat-datepicker [touchUi]="deviceService.isMobile() || deviceService.isTablet()" #picker></mat-datepicker>
        </mat-form-field>
      </div>
    }
    <!-- picklist -->
    @case (fieldTypes.PICKLIST.type) {
      <div class="p-dropdown-items-wrapper" [ngClass]="{'input-wrapper-p-dropdown': true, 'full-width': fullWidth}">
        @if (icon) {
          <div class="owner-icon" [style.color]="iconColor">
            <mat-icon>{{icon}}</mat-icon>
          </div>
        }
        <p-select #pSelectRef appendTo="body" [ngClass]="{'blank-option': !group.controls[controlName].value}"
          [styleClass]="isButton ? 'mat-raised-button' : ''"
          (onChange)="onMenuSelect($event.value)" [options]="options"
          (onFilter)="onFilter($event)" 
          (onClear)="onFilterClear()"
          [filter]="!(deviceService.isMobile() || deviceService.isTablet())"
          formControlName="{{controlName}}"
          placeholder="{{placeholder ? placeholder : field.name}} {{required ? ' *' : ''}}"
          [virtualScroll]="options && options.length > 100"
          [virtualScrollItemSize]="38"
         
          >
          <ng-template let-item #selectedItem>
            <span [ngClass]="{'required': needsSelect, 'default': !needsSelect}">{{ item?.label || 'empty' }}</span>
          </ng-template>
          <ng-template let-option #item>
            <span [ngClass]="option.styleClass">{{option.label||'empty'}}</span>
          </ng-template>
        </p-select>
      </div>
    }
    @case (fieldTypes.MULTI_PICKLIST.type) {
      <div class="p-dropdown-items-wrapper" [ngClass]="{'input-wrapper-p-dropdown': true, 'full-width': fullWidth}">
        <mat-form-field style="width: 100%;">
          <mat-label>{{field.name}}</mat-label>
          <mat-chip-grid #chipList>
            @for (option of selectedOptions; track option) {
              <mat-chip-row [removable] (removed)="removeOption(option)">
                <span [title]="option">{{option}}</span>
                @if (!disabled) {
                  <mat-icon matChipRemove svgIcon="cancel"></mat-icon>
                }
              </mat-chip-row>
            }
            <input #optionInput [matAutocomplete]="auto"
              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (input)="onSearchInput($event)" #autoTrigger="matAutocompleteTrigger"
              [matChipInputAddOnBlur]="false" (matChipInputTokenEnd)="onMultiSelect($event, field)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOption($event)" panelWidth="auto">
              @for (option of filteredOptions | async; track option) {
                <mat-option  [value]="option.value">
                  {{option.label}}
                </mat-option>
              }
              @if ((filteredOptions | async)?.length === 0) {
                <mat-option [value]="" disabled>
                  No options available
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      }
      <!-- barcode -->
      @case (fieldTypes.BARCODE.type) {
        <div>
          <ah-barcode-input placeholder="{{field.name}}" [disable]="disabled" formControlName="{{controlName}}" [controlName]="controlName" [group]="group" #input>
          </ah-barcode-input>
        </div>
      }
      <!-- input -->
      @default {
        <mat-form-field [ngClass]="{'full-width': fullWidth}" [ngStyle]="{'display': (field.canonical_name !== 'created_by_user') ? 'block' : 'none'}">
          <mat-label>{{field.name}}</mat-label>
          @if ((field.type === fieldTypes.LONG_TEXT_AREA.type || field.type === fieldTypes.HUGE_TEXT_AREA.type) && autoSize) {
            <textarea matInput   cdkTextareaAutosize #autosize="cdkTextareaAutosize" [cdkAutosizeMinRows]="1" [cdkAutosizeMaxRows]="10" formControlName="{{controlName}}"
              [required]="required" #input>
            </textarea>
          }
          <!-- please don't remove the next line- matTextareaAutosize breaks tables on firefox when adding or removing rows -->
          @if ((field.type === fieldTypes.LONG_TEXT_AREA.type || field.type === fieldTypes.HUGE_TEXT_AREA.type) && !autoSize) {
            <textarea matInput
              formControlName="{{controlName}}" [required]="required" #input>
            </textarea>
          }
          @if (field.type !== fieldTypes.LONG_TEXT_AREA.type && field.type !== fieldTypes.HUGE_TEXT_AREA.type && field.type !== fieldTypes.NUMBER.type) {
            <input
              matInput
              type="{{field.input_type}}"
              pattern="{{field.pattern ? field.pattern.pattern : ''}}"
              maxlength="{{field.max_length ? field.max_length : ''}}"
              formControlName="{{controlName}}"
              [required]="required"
              #input
              (blur)="onBlur()"
              >
          }
          @if (field.type === fieldTypes.NUMBER.type) {
            <input
              matInput
              type="number"
              pattern="{{field.pattern ? field.pattern.pattern : ''}}"
              formControlName="{{controlName}}"
              [required]="required"
              #input
              max="{{field.max ? field.max : ''}}"
              min="{{field.min ? field.min : ''}}"
              >
          }
          @if (field.max_length && group.get(controlName).hasError('maxLength')) {
            <mat-error>This is too long
            </mat-error>
          }
          @if (field.pattern && group.get(controlName).hasError('pattern')) {
            <mat-error>
            {{field.pattern.message}}</mat-error>
          }
        </mat-form-field>
      }
    }
  </div>
  
